<template>
  <PortalWidget :widget="{title: 'Call Flows', iconClass: 'fa fa-sitemap'}">
    <template v-slot:headerContent>
      <div class="header-extra">
        <input
          v-model="filters.name.value"
          type="search"
          :placeholder="$t('SEARCH_CALL_FLOWS')"
          class="form-control input-md widget-header-input m-r-10"
        >
      </div>
    </template>
    <CallFlowsView :filters="filters" />
  </PortalWidget>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import PortalWidget from '@/core/components/PortalWidget.vue';
import CallFlowsView from './CallFlowsView.vue';
export default {
  components: {
    PortalWidget,
    CallFlowsView
  },
  data() {
    return {
      filters: {
        name: { value: '', keys: ['name', 'id'] }
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>